/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealclosed_Noticeshare3Inputs */

const en_coinvestments_dealclosed_noticeshare3 = /** @type {(inputs: Coinvestments_Dealclosed_Noticeshare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is closed and read-only. Notes remain editable.`)
};

/**
* | output |
* | --- |
* | "This deal is closed and read-only. Notes remain editable." |
*
* @param {Coinvestments_Dealclosed_Noticeshare3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealclosed_noticeshare3 = /** @type {((inputs?: Coinvestments_Dealclosed_Noticeshare3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealclosed_Noticeshare3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealclosed_noticeshare3(inputs)
});
export { coinvestments_dealclosed_noticeshare3 as "coInvestments_dealClosed_noticeShare" }